import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class ProfessionalResource {
  private baseUri = '/prl/professionals';

  constructor(private ApiService: ApiService) {}

  // GET
  findProfessionalsByIds(params: {
    professionalIds: Docorga.interfaces.naturalTypes.NProfessionalObjectId[];
  }): Observable<Array<Docorga.interfaces.professional.IProfessionalPublicJson>> {
    return this.ApiService.get(`${this.baseUri}`, params);
  }
}
